<ms-khuyana-header [showHeading]="false" [showMenu]="false"></ms-khuyana-header>

<div class="wrap-content flex flex-column align-items-center">
  <span class="">
    <i class="fas fa-user-lock forbidden__icon"></i>
  </span>

  <h2 class="forbidden__heading">{{screen.noSession}}</h2>

  <span class="forbidden__link">
    <span>{{screen.goTo}}</span><a [routerLink]="['/ingresar']">{{screen.link}}</a>
  </span>
</div>